import { React, useState } from 'react'
import { useDispatch } from 'react-redux';
import { addToCart } from '../../../redux/cart.slice';
import { clearOrder } from '../../../redux/order.slice';
import { clearShipping } from '../../../redux/shipping.slice';
import { toggleCart } from '../../../redux/minicart.slice';
import * as ga from '../../../lib/ga'
import Link from 'next/link';

function BuyButton({ item,iscrosssell }) {

    const instock = (variation) => {
        if (variation.quantity > 0) {
            return true
        } else if (variation.backorder) {
            return true
        } else {
            return false
        }
    }


    const dispatch = useDispatch();

    const [added_to_cart, set_added_to_cart] = useState(false)

    const add_to_cart = (event, variation, url,role) => {
        event.preventDefault()
        // clear any pending orders they havent completed yet
        dispatch(clearOrder())
        dispatch(clearShipping())
        // always add 1 from here
        variation.url = url;
        variation.role = role;
        dispatch(addToCart({...variation, add_quantity: 1, available_quantity: variation.quantity}))
        set_added_to_cart(true)
        if(!iscrosssell){
            dispatch(toggleCart())
        }
        ga.add_to_cart(variation)

    }

    return (
        (item.variations[0].variation_status == null || item.variations[0].variation_status == '') ? (
            (item.variations.length > 1) ? (
                <div className="mx-3 mb-3">
                    <button className="btn-primary btn btn-md btn-block">View Range</button>
                </div>
            ) : (
                <>              
                    {instock(item.variations[0]) ? (
                        (added_to_cart) ? (
                            <div className="mx-3 mb-3">
                                <button
                                    onClick={(event) => add_to_cart(event, item.variations[0],item.url, item.role)}
                                    className="btn-added-to-cart btn btn-md btn-block">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="mr-1" width="16" height="16" viewBox="0 0 16 16">
                                        <path id="Path_149" data-name="Path 149" d="M7.667,10l1.556,1.556,3.111-3.111M17,10a7,7,0,1,1-7-7A7,7,0,0,1,17,10Z" transform="translate(-2 -2)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                                    </svg>
                                    Added To Trolley
                                </button>
                            </div>
                        ) : (
                            <div className="mx-3 mb-3">
                                <button
                                    onClick={(event) => add_to_cart(event, item.variations[0],item.url, item.role)}
                                    className="btn-primary btn btn-md btn-block">
                                    Add To Trolley
                                </button>
                            </div>
                        )
                    ) : (
                        <div className="mx-3 mb-3">                    
                            <button
                                disabled
                                className="btn btn-md btn-disabled btn-block">
                                Out Of Stock
                            </button>
                        </div>
                    )}
                </>
            )
        ):(
            <>
            <div className="mx-3 mb-3">
                {item.variations[0].variation_status == 'Obsolete' ? (
                    <button
                        className="btn btn-md btn-block cursor-default bg-rose-600">
                        Obsolete
                    </button>
                ) : ('')}
                {item.variations[0].variation_status == 'Superseded' ? (
                    <>
                        {item.variations[0].superseded_by ? (
                            <Link href={
                                        item.variations[0].superseded_by.role === 'merchant'
                                            ? `/merchant/product/${item.variations[0].superseded_by.url}`
                                            : `/product/${item.variations[0].superseded_by.url}`
                                    }>
                            <a
                                className="bg-rose-600 btn btn-md btn-block">
                                Superseded By {item.variations[0].superseded_by.sku}
                            </a>
                            </Link>
                        ) : (
                            <Link href="/replacement-coming-soon">
                            <a
                                className="btn btn-md btn-block bg-rose-600">
                                Superseded By TBC
                            </a>
                            </Link>
                        )}
                    </>
                ) : ('')}
                {item.variations[0].variation_status == 'Price On Application' ? (
                    <button
                        className="btn btn-md btn-block cursor-default bg-gray-500">
                        Price on Application
                    </button>
                ) : ('')}
            </div>
            </>
        )
    );
}

export default BuyButton;
